"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.SidePanelWrapper = exports.Header = exports.Content = exports.CloseButton = exports.Backdrop = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SidePanelWrapper = exports.SidePanelWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__SidePanelWrapper",
  componentId: "sc-104aj6b-0"
})(["position:fixed;right:0;background-color:#fff;bottom:0;box-shadow:0 0 10px 0 rgba(0,0,0,0.1);z-index:1000;transition:transform 0.3s ease-in-out;pointer-events:", ";padding:24px;left:0;width:100%;height:90%;transform:", ";border-top-right-radius:8px;border-top-left-radius:8px;@media only screen and (min-width:768px){left:unset;height:100%;transform:translateY(0);border-top-right-radius:0;top:0;width:600px;max-width:80%;transform:", ";border-bottom-left-radius:8px;}"], function (p) {
  return p.isOpen ? 'auto' : 'none';
}, function (p) {
  return p.isOpen ? 'translateY(0)' : 'translateY(100%)';
}, function (p) {
  return p.isOpen ? 'translateX(0)' : 'translateX(100%)';
});
var Header = exports.Header = _styledComponents["default"].div.withConfig({
  displayName: "styles__Header",
  componentId: "sc-104aj6b-1"
})(["display:flex;align-items:center;justify-content:space-between;height:36px;margin-bottom:16px;"]);
var Title = exports.Title = _styledComponents["default"].h2.withConfig({
  displayName: "styles__Title",
  componentId: "sc-104aj6b-2"
})(["font-size:24px;font-weight:400;margin:0;"]);
var CloseButton = exports.CloseButton = _styledComponents["default"].button.withConfig({
  displayName: "styles__CloseButton",
  componentId: "sc-104aj6b-3"
})(["position:relative;width:20px;height:20px;border:none;background:none;cursor:pointer;transition:opacity 0.3s ease-in-out;opacity:1;&:hover{opacity:0.5;}&:active{opacity:0.8;}&:after,&:before{content:'';position:absolute;top:50%;left:50%;width:24px;height:2px;background-color:", ";transform:translate(-50%,-50%) rotate(45deg);}&:before{transform:translate(-50%,-50%) rotate(-45deg);}"], _palette.commonPalette.iconDefault);
var Content = exports.Content = _styledComponents["default"].div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-104aj6b-4"
})(["width:100%;height:calc(100% - 48px);"]);
var Backdrop = exports.Backdrop = _styledComponents["default"].button.withConfig({
  displayName: "styles__Backdrop",
  componentId: "sc-104aj6b-5"
})(["position:fixed;top:0;right:0;bottom:0;left:0;background-color:rgba(0,0,0,0.5);z-index:999;opacity:", ";transition:opacity 0.3s ease-in-out;pointer-events:", ";border:none;outline:none;tab-index:", ";&:active{outline:none;}"], function (p) {
  return p.showBackdrop ? 1 : 0;
}, function (p) {
  return p.showBackdrop ? 'auto' : 'none';
}, function (p) {
  return p.showBackdrop ? 0 : -1;
});
//# sourceMappingURL=styles.js.map